<template>
  <div class="projectLevelEvents"></div>
</template>

<script>
import eventBus from '@refapp/eventbus-js';

export default {
  name: 'rfp-mctb-events',
  props: {
    productDataLayer: { type: Object, required: true },
  },
  created() {
    eventBus.on('rfp-mctb-datalayer-event-new', () => {
      eventBus.emit('rfp-mctb-datalayer-event', this.productDataLayer);
    });
  },
};
</script>
